export const RESPONSE_ERROR_CODE_LIST = {
    404: 'A keresett oldal nem talÃ¡lhatÃ³',
    500: 'Ismeretlen hiba',
    'default': 'Ismeretlen hiba',
};
